// extracted by mini-css-extract-plugin
export default {"error":"CustomerModal_error__tHsXf"};